const nls = {
    ASSOCIATED_USERS: "关联用户",
    ONLINE_USERS: "在线用户",
    PORT_STATUS: "端口状态",
    CACHED: "Cached(MB)",
    BUFFERS: "Buffers(MB)",
    SYSTEM: "System(%)",
    FILE_COUNT: "项目个数",
    IUSED: "Inode使用率(%)",
    IFREE: "Inode剩余量",
    WRITE: "每秒完成的写I/0设备次数",
    AWAIT: "平均每次I/O操作的等待时间",
    AVGQU_SZ: "平均I/O队列长度",
    DISK_PERCENTFULL: "Disk使用率(%)",
    DISK_FREE_SPACE: "剩余空间(G)",
    DISK_TOTAL: "总空间(G)",
    MATCH_CONTENT: "出现次数",
    ADD_MATCH_CONTENT: "新增匹配次数",
    UPDATE_DATE: "修改时间",
    MEMORY_PERCENTFULL: "物理内存利用率(%)",
    MEMORY_FREE_SPACE: "物理内存剩余空间(MB)",
    IN_BYTES_PER_SECOND: "接收速率(kbits/s)",
    ERRORS_DATA_PACKET: "错误数据包数(个)",
    OUT_BYTES_PER_SECOND: "发送速率(kbits/s)",
    LEVEL_FILTER_NUMBER: "记录总数",
    RECORD_COUNT: "记录数",
    FILTER_COUNT: "过滤数",
    PROCESS_VIRTUAL_MEMORY: "占用虚拟内存(MB)",
    INT_VALUE1: "返回值1",
    STRING_VALUE1: "返回值3",
    STRING_VALUE2: "返回值4",
    INT_VALUE2: "返回值2",
    IDLE_WORKERS: "闲置进程数(个)",
    BYTES_PER_SEC: "传送速率(字节数/秒)",
    BUSY_WORKERS: "激活进程数(个)",
    TOTAL_KBYTES: "总传输字节(KB)",
    TOTAL_ACCESSES: "总访问数(个)",
    BYTES_PER_REQ: "每个请求的字节数(字节)",
    REQ_PER_SEC: "请求速率(字节数/秒)",
    AP_BEARING_USER_AVG: "平均每个AP的承载用户量",
    CONNECTED_USERS: "连接用户数",
    ADDRESS: "地址",
    CONNECT_SUCCESS_RATE: "连接成功率(%)",
    ONLINE_USER: "在线用户数",
    HOSTNAME: "主机名",
    AP_CONNECT_SUCCESSRATE: "连接成功率(%)",
    CPU_UTILIZATION: "CPU利用率(%)",
    CURRENT_CHANNEL_2G: "当前2.4G信道",
    CURRENT_CHANNEL_5G: "当前5G信道",
    AP_FAULT_RATE: "AP故障率(%)",
    AP_DOWNSIDE_FLOW: "AP_DOWNSIDE_FLOW",
    AP_UPSIDE_FLOW: "AP_UPSIDE_FLOW",
    MAC_ADDRESS: "MAC地址",
    SUPER_IDLE: "超闲占比(%)",
    SUPER_BUSY: "超忙占比(%)",
    SWAP_TOTAL: "Swap总量(MB)",
    PHYSICAL_MEMORY_USAGE: "物理内存使用率(%)",
    SWAP_USAGE: "Swap使用率(%)",
    PHYSICAL_MEMORY_TOTAL: "物理内存总量(MB)",
    PHYSICAL_FREE_SPACE: "物理剩余空间(MB)",
    AP_SIGNAL_2G: "2.4G天线信号强度(ASU)",
    AP_SIGNAL_5G: "5G天线信号强度(ASU)",
    WLAN_ONLINE_PEOPLE: "成功认证在线人数",
    Scan_DB_TotalNum: "Scan_DB_TotalNum",
    Scan_Device_TotalNum: "Scan_Device_TotalNum",
    CISCO_CPU: "Cisco 5秒 CPU使用率(%)",
    CISCO_MEMORY: "剩余内存(MB)",
    STATUS: "状态",
    FILENAMEISNOTCHANGE: "文件变化状态（已改变（1），未改变（2））",
    UTILIZATION_PERCENTAGE: "CPU平均利用率(%)",
    USER: "user(%)",
    NICE: "nice(%)",
    STEAL: "steal(%)",
    IOWAIT: "iowait(%)",
    IDLE: "idle(%)",
    COLUMN: "列数",
    ROWS: "行数",
    SIZE: "文件大小(KB)",
    DISK_ERROR: "最新错误信息",
    HEALTH_DEGREE: "健康度",
    INODES: "Inodes总量",
    SVCTM: "平均每次I/O操作的服务时间",
    UTIL: "每秒I/O操作百分率(%)",
    READ: "每秒完成的读I/O设备次数",
    CURRENT_VALUE: "当前值",
    THRESHOLD_VALUE: "阀值",
    ERROR_VALUE: "最差值",
    COUNTER_STATUS: "计数器状态",
    COUNTER_DATA: "数据",
    CURRENT_TEMPERATURE: "当前温度",
    TOTAL: "总数",
    WARNING_MONITOR: "危险监测器  ",
    GOOD_MONITOR: "正常监测器  ",
    GOOD_PERCENT: "正常率(%)        ",
    ERROR_MONITOR: "错误监测器数  ",
    TIME_OUT: "超时监测器",
    ERROR_PERCENT: "错误率(%) ",
    WARNING_PERCENT: "危险率(%)",
    FAN_STATUS: "风扇状态(OK(1))",
    CHANNEL_RUN_STATUS: "光纤通道状态  ",
    MATCH_VALUE: "匹配内容",
    FILES_SIZE: "文件大小(KB)",
    FILE_SIZE: "文件大小(bytes)",
    DISK_NUMBER_READ_AVERAGED: "磁盘每秒平均读取请求数(个)",
    DISK_WRITE: "磁盘写入速度(KBps)",
    HEALTHSTATE: "健康状况",
    MEMERYSIZE: "分配内存(MB)",
    DISK_READ: "磁盘读取速度(KBps)",
    NETWORK_RECEIVED: "数据接收速度(KBps)",
    RECEIVE_TIME: "接收时间(s)",
    SEND_TIME: "发送时间(s)",
    MEMORY_VIRTUAL_TOTAL: "虚拟内存总空间(MB)",
    MEMORY_VIRTUAL_FREE_SPACE: "虚拟内存剩余空间(MB)",
    MEMORY_TOTAL: "物理内存总空间(MB)",
    MEMORY_BUFFERS: "buffers(MB)",
    MEMORY_CACHED: "cached(MB)",
    MEMORY_VIRTUAL_PERCENTFULL: "虚拟内存利用率(%)",
    MODULE_STATUS: "板卡状态(on(2),off(3))",
    ACONNECTIONS: "可用连接数",
    CLOCKREAD: "当前等待读锁数",
    CCONNECTIONS: "当前连接数",
    CLOCKTOTAL: "当前等待锁总数",
    GLOBALLOCKPEF: "全局锁时间比例",
    CLOCKWRITE: "当前等待写锁数",
    QUERYTHROUGHPUT: "查询吞吐量(%)",
    KEY2: "列2",
    COUNT: "记录数",
    VALUE1: "值1",
    VALUE2: "值2",
    VALUE3: "值3",
    KEY3: "列3",
    KEY1: "列1",
    QUESTIONS: "上次监测后已执行长时间查询总数(条)",
    QUERIES: "上次监测后已执行查询总数(条)",
    OPEN_TABLES: "当前打开的数据表总数(条)",
    THREADS_RUNNING: "当前活动线程总数(个)",
    SLAVE_SQL_RUNNING: "主从复制SQL状态",
    SECONDS_BEHIND_MASTER: "主从复制滞后时间",
    SLAVE_IO_RUNNING: "主从复制IO状态",
    INNODB_BUFFER_POOL_PAGES_TOTAL: "缓冲池总大小(页数)",
    INNODB_BUFFER_POOL_PAGES_DIRTY: "当前脏页(页)",
    INNODB_BUFFER_POOL_PAGES_FREE: "空页数(页)",
    INNODB_PAGE_SIZE: "页大小(Kb)",
    INNODB_BUFFER_POOL_PAGES_DATA: "包含数据页(页)",
    INNODB_BUFFER_POOL_PAGES_LATCHED: "在InnoDB缓冲池中锁定的页数(页)",
    CONNECTE_HOST_COUNT: "连接设备(连接数)",
    CONNECTEDS: "总连接数",
    NETWORK_ERRORS_DATA_PACKET: "错误数据包数(个)",
    NETWORK_IN_BYTES_PER_SECOND: "接收速率(Kbit/s)",
    NETWORK_OUT_BYTES_PER_SECOND: "发送速率(Kbit/s)",
    NETWORK_IN_TOTAL_BYTES: "接收总数据(KB)",
    NETWORK_OUT_TOTAL_BYTES: "发送总数据(KB)",
    NETWORK_5mCPU: "cpu5分钟使用率(%)",
    WRITING: "正在写的",
    READING: "读取的请求头次数",
    WAITING: "当前活动的长连接数",
    CONNECTIONS_PER_SECONDS: "每个连接包含的请求数",
    HANDLES_REQUESTS: "已处理请求数",
    HANDLED_CONNECTIONS: "已处理连接数",
    ACTIVE_CONNECTIONS: "活动连接数",
    ACCEPTED_CONNECTIONS: "已接受连接数",
    MATCH_ID: "事件ID",
    MATCH_SOURCE: "源名称",
    EVENT_TIME: "事件时间",
    TOTAL_MINUTE: "每分钟累计连接数",
    LOGONS_CUMULATIVE: "累计连接数",
    LOGONS_CURRENT: "当前连接数(个) ",
    LOCK: "数据库锁数量(个)",
    SESSION: "Session数(个)",
    TRANSACTIONS: "每秒事务数(个)",
    DEADLOCK: "死锁数量(个)",
    HITRATE: "缓冲池命中率(%)",
    CURSOR: "游标数(个) ",
    CACHEITRATE: "库cache命中率(%)",
    SORTS_MEMORY: "内存排序总次数",
    TOTAL_LOGICAL_IO: "逻辑IO总次数",
    USER_COMMIT_MINUES: "每分钟提交次数",
    SORTS_DISK: "磁盘排序总次数",
    SORTS_MEMORY_MINUES: "每分钟内存排序次数",
    LOGICAL_IO: "每分钟逻辑IO次数",
    TOTAL_PHYSICAL_IO: "物理IO总次数",
    SORTS_DISK_MINUES: "每分钟磁盘排序次数",
    USER_ROLLBACKS_MINUES: "每分钟回滚次数",
    USER_ROLLBACKS: "回滚总次数",
    USER_COMMIT: "提交总次数",
    PHYSICAL_IO: "每分钟物理IO次数",
    REDO_BUFFERS: "日志缓冲区(M)",
    DATABASE_BUFFERS: "数据库缓冲区(M)",
    FIXED_SIZE: "引导建立SGA的区域(M)",
    FARIABLE_SIZE: "变量区域(M)",
    USEDPER: "使用率(%)",
    FREEPER: "剩余率(%)",
    USED: "使用空间(MB)",
    FREE: "自增剩余(MB)",
    STATUS_PORT: "状态(200为端口开启)",
    POWER_STATUS: "电源状态(OK(1))",
    PROCESS_CPU: "CPU使用率(%)",
    THREAD_COUNT: "总线程数",
    PROCESS_MEMORY: "占用物理内存(MB)",
    PROCESS_MEMORY_PERCENT: "内存利用率(%)",
    PROCESS_IO_READ: "进程读IO速率(KB/s)",
    PROCESS_IO_WRITE: "进程写IO速率(KB/s)",
    SERVICE_CPU: "服务CPU使用率(%)",
    SERVICE_MEMORY: "服务占用物理内存(MB)",
    SERVICE_VIRTUAL_MEMORY: "服务占用虚拟内存(MB)",
    SERVICE_THREAD_COUNT: "服务总线程数",
    SERVICE_IO_READ: "服务读IO速率(KB/s)",
    SERVICE_IO_WRITE: "服务写IO速率(KB/s)",
    TOTALMATCHES: "总匹配数",
    ADDROWS: "增加行数",
    ADDMATCHS: "增加匹配数",
    TOTALROWS: "总行数",
    ROUND_TRIP_TIME: "往返时间(ms)",
    PERCENT_GOOD: "包成功率(%)",
    INPUT_VOLTAGE: "输入电压(V)",
    STATE_FAN: "风机状态(on(2)，off(3))",
    OPERATING_MODE1: "运行模式(自动(1),手动(2))",
    OUTPUT_VOLTAGE: "输出电压(V)",
    STATE_SYSTEM: "系统状态(on(1)，off(2)，standby(3))",
    LNNER_COMM_FAILURE: "空调通讯状态(no(2)，yes(3))",
    CURRENT_VOLTAGE: "当前市电电压(V)",
    PHASE_A: "phaseA(V)",
    COMPRESSOR_LOCKOUT: "压缩机锁定",
    PHASE_C: "phaseC(V)",
    UPS_TEMPERATURE: "ups温度(℃)",
    HUMIDIFY_MODE: "加湿状态(on(2)，off(3))",
    BATTERY_TEMPERATURE: "电池温度(℃)",
    HIGH_TEMPERATURE: "高温告警(no(2)，yes(3))",
    LOW_PRESSURE: "低压告警(no(2)，yes(3))",
    ACTIVE_ENERGY: "ActiveEnergy(Wh)",
    SENSOR_BOARD_FAILURE: "传感器板故障(no(2)，yes(3))",
    OPERATING_MODE: "供电方式(状态 3 = 市电逆变供电)",
    PHASE_B: "phaseB(V)",
    RMS_CURRENT: "RmsCurrent(单位为A，最大值为16A)",
    DISCHARGE_TEMPERATURE: "排气温度故障(no(2)，yes(3))",
    POWER_LOST: "电源丢失(no(2)，yes(3))",
    HUMIDITY_LOW: "低湿告警(%)",
    LOW_TEMPERATURE: "低温告警(no(2)，yes(3))",
    STATE_COOLING: "制冷状态(on(2)，off(3))",
    OUTPUT_CURRENT: "输出电流(A)",
    HUMIDITY_HIGH: "高湿告警(%)",
    HUMIDIFIER_FAILURE: "加湿器故障(no(2)，yes(3))",
    ACTUAL_VOLTAGE: "电池电压(V)",
    BYPASS_VOLTAGE: "BypassVoltage(V)",
    TEMPERATURE_HIGH: "高温告警(C)",
    TEMPERATURE_LOW: "低温告警(C)",
    STATE_HUMDIFYING: "加湿状态(on(1)，off(2))",
    REHEAT_LOCKOUT: "再加热锁定",
    BASE_STATUS: "开关机状态(状态：on(2),off(3),shutdown(4))",
    RESIDUAL_CAPACITY: "电池剩余容量(%)",
    BATTERY_VOLTAGE: "电池电压(V)",
    OUTPUT_FREQUENCY: "输出频率(Hz)",
    BATTERY_STATUS: "电池状态(on(2),off(3))",
    OUTPUT_LOAD: "输出负载(%)",
    HIGH_PRESSURE: "高压告警(no(2)，yes(3))",
    LOAD_POWER: "负载功率(W)",
    HUMIDITY: "湿度(%)",
    COIL_FROZE: "盘管冻结(no(2)，yes(3))",
    HEAT_MODE: "加热状态(on(2)，off(3))",
    HUM_LOCKOUT: "加湿器锁定",
    RETURN_CODE0: "返回值1",
    RETURN_CODE4: "返回值5",
    RETURN_CODE3: "返回值4",
    RETURN_CODE2: "返回值3",
    RETURN_CODE1: "返回值2",
    RETURN_CODE5: "返回值6",
    NETWORK_1mCPU: "CPU1分钟使用率(%)",
    NETWORK_CPU: "CPU使用率(%)",
    NETWORK_5sCPU: "CPU5秒钟使用率(%)",
    DISK_TOTAL_SPACE: "总空间(G)",
    DISK_INCREASE_VALUE: "磁盘空间增长值(M)",
    DISK_UTILIZATION: "磁盘使用率(%)",
    DISK_INCREASE_RATE: "磁盘空间增长率(%)",
    INTERFACE_OUT_UTILIZATION: "发送带宽比(%)",
    INTERFACE_IN_UTILIZATION: "接收带宽比(%)",
    OUT_LOSSRATE: "输出丢包率(%)",
    IF_INOCTET_SPEED: "接收速率(KBit/s)",
    IF_OPERSTATUS: "接口状态",
    IN_LOSSRATE: "输入丢包率(%)",
    Buffer: "Buffer",
    NETWORK_USAGE: "内存使用率(%)",
    VIRTUAL_TOTAL_SPACE: "虚拟内存总空间(MB)",
    VIRTUAL_MEMORY_UTILIZATION: "虚拟内存利用率(%)",
    NETWORK_MEMORY: "剩余内存(MB)",
    VIRTUAL_FREE_SPACE: "虚拟内存剩余空间(MB)",
    Cache: "Cache",
    PHYSICAL_TOTAL_SPACE: "物理内存总空间(MB)",
    PHYSICAL_MEMORY_UTILIZATION: "物理内存利用率(%)",
    NETWORK_TOTAL_MEMORY: "总内存(MB)",
    IF_OUTOCTET_SPEED: "发送速率(KBit/s)",
    PROCESS_UTILIZATION: "内存使用率(%)",
    PROCESS_COUNT: "进程总数",
    ALLOCATED_MEMORY: "使用内存空间(MB)",
    SWAP_TOTAL_SPACE: "Swap总空间(G)",
    SWAP_FREE_SPACE: "Swap剩余空间(G)",
    SWAP_UTILIZATION: "Swap使用率(%)",
    IP: "IP地址",
    UPTIME: "设备运行时间",
    PAGE_LIFE_EXPECTANCY: "页若不被引用将在缓冲区池中停留的秒数(s)",
    CHECKPOINT_PAGES_SEC: "由要求刷新所有脏页的检查点或者其他操作每秒刷新到磁盘的页数(页/s)",
    PAGE_WRITES_SEC: "所发出的物理数据库页写入的数目(页)",
    PAGE_READS_SEC: "每秒发出的物理数据库页读取数(页)",
    LAZY_WRITES_SEC: "每秒Layzy_writers数(个)",
    BUFFER_CACHE_HIT_RATIO: "Buffer Cach击中率(%)",
    CACHE_OBJECTS_IN_USE: "高速缓存已使用的对象个数(个)",
    CACHE_PAGES: "高速缓存对象所使用的8(KB)页的数目(页)",
    CACHE_OBJECT_COUNTS: "高速缓存中高速缓存的对象数(个)",
    CACHE_HIT_RATIO: "高速缓存命中次数和查找次数的比率(%)",
    TOTAL_SERVER_MEMORY: "SQLServer使用的内存总量(KB)",
    CONNECTION_MEMORY: "维护连接的动态内存(KB)",
    MEMORY_GRANTS_OUTSTANDING: "每秒成功获得一个工作空间内存授权的进程总数(个)",
    OPTIMIZER_MEMORY: "查询优化的内存总数(KB)",
    SQL_CACHE_MEMORY: "动态SQL高速缓存的动态内存总数(KB)",
    NUMBER_OF_DEADLOCKS: "每秒死锁数",
    LOCK_REQUESTS: "每秒请求锁",
    AVERAGE_WAIT_TIME: "平均等待时间",
    LOG_FILE_SIZE: "日志文件大小(M)",
    DATABASE_SIZE: "数据库所占空间(M)",
    TRANSACTIONS_SEC: "事务数/秒",
    DATA_FILE_SIZE: "数据文件大小(M)",
    ACTIVE_TRANSACTIONS: "事务活动连接数",
    PERCENT_LOG_USED: "LOG文件使用率",
    SQL_RE_COMPILATIONS_SEC: "每秒的SQL重新编译数(条)",
    BATCH_REQUESTS_SEC: "每秒收到的Transact-SQL命令批数(批)",
    SQL_COMPILATIONS_SEC: "每秒的SQL编译数(条)",
    AUTO_PARAM_ATTEMPTS_SEC: "每秒的自动参数化尝试数(条)",
    LOGOUTS_SEC: "每秒开始的注销操作总数(个)",
    LOGINS_SEC: "每秒启动的登录数(个)",
    USER_CONNECTIONS: "用户连接数(个)",
    SSL_SIZE: "文件大小(bytes)",
    WRITESTATUS: "写缓存状态",
    READ_HIT_RATIO: "读缓存命中",
    DIRTY_CACHE_PAGE: "脏缓存页",
    READSTATUS: "读缓存状态",
    CACHE_PAGE_SIZE: "缓存页大小",
    WRITE_HIT_RATIO: "写缓存命中",
    HARD_WRITE_ERRORS: "HARD写错误数",
    USER_CAPACITY: "用户容量",
    SOFT_WRITE_ERROR: "SOFT写错误数",
    CAPACITY: "容量  ",
    HARD_READ_ERRORS: "HARD读错误数",
    DISK_STATUS: "状态",
    SOFT_READ_ERROR: "SOFT读错误数",
    FAULTS_STATUS: "故障状态",
    EventLog1: "EventLog1",
    EventLog0: "EventLog0",
    EventLog: "EventLog",
    EventLog2: "EventLog2",
    PROCESSORS_STATUS: "处理器状态",
    SANRUN_STATUS: "存储设备状态",
    ALLOCATE_MANAGE_SPACE: "已经分配空间(TB)",
    TOTAL_MANAGED_SPACE: "总空间(TB)",
    VOLUME_LUN_SIZE: "卷大小(TB)",
    VOLUME_RUN_STATUS: "卷状态  ",
    KEYWORD: "关键词",
    IS_MATCH: "是否匹配(1=是,0=否)",
    CHECK_DATETIME: "响应时间",
    TEMPERATURE: "温度(℃)",
    TOTAL_VOLTAGE: "总电压值",
    SOH: "SOH(%)",
    SOC: "SOC(%)",
    REMAIN_CAPACITY:"电池包剩余容量",
    FULL_CAPACITY:"电池包总容量",
    TOTAL_CURRENT: "总电流值",
    BATTERY_SECTIONS: "电池节数",
    BATTERY_TEMPERATURES: "温度数",
    BATTERY_HIGHT_SECTION : "最高电压电池节",
    BATTERY_LOW_SECTION:  "最低电压电池节",
    BATTERY_REMAIN_CAPACITY:  "剩余容量(mA)",
    LAST_ALARM_TIME:  "最后一次告警时间",
    ADD_ALARM_COUNT:  "新增告警数",
    CYCLE:  "循环次数值(次)",
    VOLTAGE: "电压值(mV)",
    BALANCE: "均衡",
    RANDOM_NUMBER_A: "RANDOM_NUMBER_A",
    RANDOM_NUMBER_B: "RANDOM_NUMBER_B",
    TOMCAT_SIZE: "页面大小(byte)",
    DOWNLOAD_TIME: "下载时间(ms)",
    SESSIOINS: "当前总会话数",
    URL_SIZE: "文件大小(bytes)",
    COUNTS: "出现次数",
    CONTENT_MATCH: "匹配内容",
    DISK_NUMBER_WRITE_AVERAGED: "磁盘每秒平均写入请求数(个)",
    NUMETHERNETCARDS: "网卡个数",
    GUESTMEM: "内存利用率(%)",
    CPURATE: "CPU使用率(%)",
    IPADDRESS: "IP地址",
    RUNINGTIME: "正常运行时间(m)",
    NUMCPU: "CPU个数",
    DEVICE_WRITE_LATENCY: "物理设备写入滞后时间(s)",
    MEMORYRESERVATION: "预留(MB)",
    POWERSTATE: "电源状态",
    NETWORK_TRANSMITTED: "数据传输速度(KBps)",
    DEVICE_READ_LATENCY: "物理设备读取滞后时间(s)",
    HOSTCPU: "主机CPU(MHZ)",
    DATASTORE_FREE_CAPACITY: "数据存储剩余容量(GB)",
    DATASTORE_UTILIZATION: "使用率(%)",
    DATASTORE_TOTAL_CAPACITY: "数据存储总容量(GB)",
    CPU_TOTAL_CAPACITY: "CPU总容量(MHz)",
    CPU_USED_CAPACITY: "CPU使用容量(MHz)",
    HOST_USER: "主机名称",
    PRODUCT_TYPE: "产品类型",
    NIC_NUMBER: "网卡个数",
    CPU_NUMBER: "CPU个数",
    HOST_VERSION: "主机版本",
    MEMORY_USED_CAPACITY: "内存使用容量(MB)",
    MEMORY_TOTAL_CAPACITY: "内存总容量(MB)",
    MEMORY_UTILIZATION: "内存利用率(%)",
    MAXIMUM_ALLOWED_POWER: "使用上限(瓦特)",
    POWER_USAGE: "使用情况(瓦特)",
    NOTRUNNING_VIRTUALMACHINE_AMOUNT: "未运行虚拟机数",
    RUNNING_VIRTUALMACHINE_AMOUNT: "已运行虚拟机数",
    VIRTUALMACHINE_AMOUNT: "虚拟机总数",
    ISNOTLEAK: "ISNOTLEAK",
    CLUSTERNAME: "Cluster名称",
    MULTICASTMESSAGESLOSTCOUNT: "丢失的消息数",
    ALIVESERVERCOUNT: "激活服务器的数量",
    SERVER: "Server",
    CONNECTIONDELAYTIME: "连接平均耗时（毫秒）",
    WAITTINGFORCONNECTIONCURRENTCOUNT: "当前等待连接数",
    CONN_CUR_CAPACITY: "当前连接池容量",
    WAITSECONDSHIGHCOUNT: "历史最长等待连接时间（秒）",
    NUMAVAILABLE: "当前可利用的连接数",
    FAILURESTORECONNECTCOUNT: "二次连接失败的次数",
    CONN_CAPACITYHIGH: "历史最大连接池容量",
    NUMUNAVAILABLE: "当前不可利用的连接数",
    ACTIVECONNECTIONSHIGHCOUNT: "历史最大活动连接数",
    CONNECTION_TOTAL: "连接总数",
    ACTIVECONNECTIONSCURRENTCOUNT: "当前活动连接数",
    HIGHESTNUMAVAILABLE: "历史最大可利用的连接数",
    ACTIVECONNECTIONSAVERAGECOUNT: "历史平均活动连接数",
    VERSIONJDBCDRIVER: "JDBC驱动版本",
    POOL_NAME: "连接池名称",
    POOL_STATES: "连接池的状态",
    WAITINGFORCONNECTIONHIGHCOUNT: "历史最大等待连接数",
    HIGHESTNUMUNAVAILABLE: "历史最大不可利用的连接数",
    ERROR: "系统异常",
    EXECUTETHREADTOTALCOUNT: "执行线程的总数",
    EXECUTEQUEUENAME: "队列名称",
    PENDINGREQUESTOLDESTTIME: "挂起请求最长时间",
    SERVICEREQUESTTOTALCOUNT: "队列已经处理的请求数",
    EXECUTETHREADCUENTIDLECOUNT: "当前空闲的执行线程数",
    PENDINGREQUESTCURRENTCOUNT: "队列中未处理的请求数",
    HEAPSIZECURRENT: "当前堆总空间(字节)",
    NAME: "名称",
    HEAPFREECURRENT: "当前堆可用空间(字节百分比)",
    HEAPUSEDSIZE: "当前堆已使用空间(字节百分比)",
    JMS_CONN_TOTAL: "JMS的连接总数",
    JMS_CONN_HIGH: "JMS的最高连接数",
    JMS_SESSION_HIGH: "最高JMS Session数",
    JMS_MSG_PENDING: "未处理JMS消息数",
    JMS_MSG_SENDED: "JMS发送消息数",
    JMS_SERVER_TOTAL: "JMS Server总数",
    JMS_CONN_CUR: "JMS当前的连接总数",
    JMS_SESSION_TOTAL: "JMS Session的总数",
    JMS_MSG_RECEIVED: "已接收JMS消息数",
    JMS_SESSION_CUR: "当前JMS Session数",
    JMS_SERVER_CUR: "当前JMS Server总数",
    JMS_SERVER_HISTORY: "JMS Server历史中最高总数",
    LISTENADDRESS: "监听地址",
    ADMINISTRATIONPORT: "管理端口",
    ADMINSERVERLISTENPORT: "管理服务监听端口",
    SOCKETSOPENEDTOTALCOUNT: "打开的Socket的总数",
    CONNECTIONSCOUNT: "当前连接数",
    LISTENPORT: "监听端口",
    SSLLISTENPORT: "SSL监听端口",
    OPENSOCKETSCURRENTCOUNT: "当前打开的Socket数量",
    RESTARTSTOTALCOUNT: "重启总次数",
    WEBAPPNAME: "WebApp名称",
    OPENSESSIONSHIGHCOUNT: "打开Session最高数",
    OPENSESSIONSCURRENTCOUNT: "当前打开Session数",
    SESSIONSOPENEDTOTALCOUNT: "打开Session总数",
    CREATECOUNT: "创建连接数",
    USETIME: "占用时间(ms)",
    CLOSECOUNT: "销毁连接数",
    WAITTIME: "等待时间(ms)",
    PERCENTUSED: "占用率(%)",
    WAITINGTHREADCOUNT: "等待数",
    POOL_SIZE: "池大小",
    FREEPOOLSIZE: "空闲池大小",
    FREE_MEMORY: "剩余内存(千字节)",
    USAGE: "CPU使用率",
    TOTAL_MEMORY: "总内存(千字节)",
    USED_MEMORY: "已用内存(千字节)",
    LIVECOUNT: "存活对话数",
    SERVER_NAME: "服务名称",
    ROLLEDBACKCOUNT: "回滚事务数",
    ACTIVECOUNT: "激活事务数",
    COMMITTEDCOUNT: "提交事务数",
    URIREQUESTCOUNT: "URL请求数",
    SERVICETIME: "响应时间(ms)",
    REQUESTCOUNT: "总请求数",
    URISERVICETIME: "URL响应时间(ms)",
    CPU_TOTAL_NUMBER: "CPU内核总数",
    ContactWay: "联系方式",
    CreateTime: "创建时间",
    DueTime: "到期时间",
    Contacts: "联系人",
    ValidityTime: "剩余有效期限(天)",
    "CPU1(%)":"CPU1(%)",
    "CPU2(%)":"CPU2(%)",
    "CPU3(%)":"CPU3(%)",
    "CPU4(%)":"CPU4(%)",
    "CPU5(%)":"CPU5(%)",
    "CPU6(%)":"CPU6(%)",
    "CPU7(%)":"CPU7(%)",
    "CPU8(%)":"CPU8(%)",
    // PostgreSQL 系列监测器（新后端新增类型）返回值翻译，与后端枚举 IT_MRI_07xx 的 description 一致
    VERSION: "数据库版本",
    MAX_CONNECTIONS: "最大连接数",
    TOTAL_CONNECTIONS: "总连接数",
    IDLE_CONNECTIONS: "空闲连接数",
    TOTAL_LOCKS: "总锁数",
    WAITING_LOCKS: "等待锁数",
    COMMITS: "提交事务数",
    ROLLBACKS: "回滚事务数",
    BLOCKS_READ: "磁盘读块数",
    BLOCKS_HIT: "缓存命中块数",
    INSERTS: "插入行数",
    UPDATES: "更新行数",
    DELETES: "删除行数",
    SEQ_SCANS: "顺序扫描数",
    IDX_SCANS: "索引扫描数",
    IDX_BLOCKS_READ: "索引磁盘读块数",
    IDX_BLOCKS_HIT: "索引缓存命中块数",
    REPLICA_COUNT: "从库数量",
    MAX_LAG_BYTES: "最大延迟字节数",
    BUFFER_HIT_RATIO: "缓存命中率(%)",
    DB_SIZE_BYTES: "数据库大小(字节)",
}

export default nls;
// module.exports = {
//     nls
// }
